// Função para formatar o CEP (somente para exibição)
export const formatCEP = (value: string | undefined): string => {
    if (!value) return '';
    const digits = value.replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  };
  